<template>
    <div class="carousel-wrapper" ref="carouselWrapper">
      <div v-if="allItems.length>0">
        <div
          class="carousel-track"
          ref="carouselTrack"
          :style="trackStyle"
          @wheel="handleWheel"
        >
          <div
            v-for="(item, index) in allItems"
            :key="item.id + '-' + index"
            class="carousel-item"
            @click="goToFile(item.url)"
          >
            <img :src="obtenerIconoDeArchivoSimple(item.url)" :alt="item.nombre" >
            <p>{{ item.nombre }}</p>
          </div>
        </div>
        <button class="carousel-arrow left" @click="scrollCarousel(-1)">
          &#10094;
        </button>
        <button class="carousel-arrow right" @click="scrollCarousel(1)">
          &#10095;
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      title: {
        type: String,
        required: false,
      },
      // Propiedad para recibir los ítems del carrusel desde el padre
      items: {
        type: Array,
        required: true,
        default: () => [],
      },
      // Opcional: para ajustar la velocidad del scroll
      scrollSpeed: {
        type: Number,
        default: 0.8,
      },
      // Opcional: para ajustar el porcentaje de zoom al pasar el mouse
      hoverScale: {
        type: Number,
        default: 1.15, // 15% de aumento
      },
      // Opcional: para ajustar el tiempo de transición del desplazamiento
      scrollTransitionDuration: {
        type: String,
        default: '0.2s',
      },
    },
    data() {
      return {
        currentScroll: 0, // Posición de desplazamiento actual del track
        itemWidth: 0, // Ancho calculado de un solo ítem del carrusel
        isTransitioning: true, // Controla la transición del track para el salto infinito
        allItems: [], // Array que contendrá los ítems originales duplicados para el efecto infinito
      };
    },
    computed: {
      tipo_archivo() {
        return "/img/icon-pdf.svg"
      },
      trackStyle() {
        // Aplica el transform X y la transición basada en el estado
        return {
          transform: `translateX(${-this.currentScroll}px)`,
          transition: this.isTransitioning
            ? `transform ${this.scrollTransitionDuration} ease-out`
            : 'none',
        };
      },
      numOriginalItems() {
        // Si recibimos 5 ítems y los duplicamos, el total de ítems originales es 5
        return this.items.length;
      },
      totalTrackWidth() {
        // El ancho total del track (incluyendo duplicados)
        return this.allItems.length * this.itemWidth;
      },
    },
    watch: {
      // Observa cambios en los ítems pasados por props
      items: {
        immediate: true, // Ejecuta el handler inmediatamente al montar
        handler(newItems) {
          // Duplicamos los ítems para el efecto infinito
          this.allItems = [...newItems, ...newItems];
          this.$nextTick(() => {
            this.calculateItemWidth();
            this.ensureInitialPosition();
          });
        },
      },
    },
    mounted() {
      // Asegurarse de que el DOM esté renderizado antes de calcular el ancho
      this.calculateItemWidth();
      // Añadir el listener para el evento 'wheel' en el track
      if(this.$refs.carouselTrack){
        this.$refs.carouselTrack.addEventListener('wheel', this.handleWheel);
      }
      // Si no hay ítems, no inicializar la posición
      if (this.allItems.length > 0) {
        this.ensureInitialPosition();
      }
    },
    beforeDestroy() {
      // Limpiar el listener para evitar fugas de memoria
      if (this.$refs.carouselTrack) {
        this.$refs.carouselTrack.removeEventListener('wheel', this.handleWheel);
      }
    },
    methods: {
      inferirMimeTypeSimplificado(nombreArchivo) {
        const extension = nombreArchivo.split('.').pop().toLowerCase();

        switch (extension) {
          case 'pdf':
            return 'application/pdf';
          case 'xls':
            return 'application/vnd.ms-excel';
          case 'xlsx':
            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          default:
            return 'default'; // Usamos una cadena 'default' para los no reconocidos
        }
      },
      obtenerUrlIconoSimplificado(mimeTypeSimplificado) {
        const iconoMap = {
          'application/pdf': '/img/icon-pdf.svg', // Icono para PDF
          'application/vnd.ms-excel': '/img/icon-excel.svg', // Icono para Excel .xls
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '/img/icon-excel.svg', // Icono para Excel .xlsx
          'default': '/img/icon-default.svg' // Icono por defecto
        };

        return iconoMap[mimeTypeSimplificado];
      },
      obtenerIconoDeArchivoSimple(nombreArchivo) {
        const mimeType = this.inferirMimeTypeSimplificado(nombreArchivo);
        return this.obtenerUrlIconoSimplificado(mimeType);
      },
      goToFile(ruta){
        window.open(ruta, '_blank');
      },
      calculateItemWidth() {
        if (this.$refs.carouselTrack && this.$refs.carouselTrack.children.length > 0) {
          const firstItem = this.$refs.carouselTrack.children[0];
          // Calcula el ancho incluyendo los márgenes
          this.itemWidth = firstItem.offsetWidth +
                           (parseFloat(getComputedStyle(firstItem).marginLeft) * 2);
        }
      },
      // Asegura una posición inicial adecuada (opcional, para centrar o inicio)
      ensureInitialPosition() {
        // Podrías inicializar currentScroll para que el primer ítem visible
        // sea el primer ítem "real" de la secuencia original
        // Por ejemplo, para mostrar el primer ítem original al inicio del track visible:
        // this.currentScroll = 0; // O si quieres que el primer ítem original esté centrado
        // this.currentScroll = (this.numOriginalItems / 2) * this.itemWidth;
        // Para este ejemplo, empezamos en 0 y el scroll arrastra.
      },
      handleWheel(event) {
        event.preventDefault(); // Evita el scroll de la página principal
  
        const scrollAmount = event.deltaY * this.scrollSpeed;
        this.currentScroll += scrollAmount;
  
        this.updateCarouselPosition();
      },
      scrollCarousel(direction) {
        this.currentScroll += direction * this.itemWidth;
        this.updateCarouselPosition();
      },
      updateCarouselPosition() {
        // Desactivar la transición para el "salto"
        this.isTransitioning = true; // Asegurarse de que esté activada por defecto
  
        // Lógica para el efecto "infinito"
        // Cuando nos desplazamos más allá de la primera mitad de los ítems
        const originalTrackWidth = this.numOriginalItems * this.itemWidth;
  
        if (this.currentScroll >= originalTrackWidth) {
          this.isTransitioning = false; // Desactiva la transición para el salto
          this.currentScroll -= originalTrackWidth;
          // Forzar un reflow para que el cambio de transform sea inmediato
          // Sin esto, Vue podría optimizar y la transición podría verse
          this.$nextTick(() => {
            this.$refs.carouselTrack.offsetWidth; // eslint-disable-line no-unused-vars
            this.isTransitioning = true; // Reactiva la transición para los próximos scrolls
          });
        }
        // Cuando nos desplazamos hacia atrás más allá del inicio de los ítems
        else if (this.currentScroll < 0) {
          this.isTransitioning = false; // Desactiva la transición para el salto
          this.currentScroll += originalTrackWidth;
          this.$nextTick(() => {
            this.$refs.carouselTrack.offsetWidth; // eslint-disable-line no-unused-vars
            this.isTransitioning = true; // Reactiva la transición
          });
        }
      },
    },
  };
  </script>
  
  <style scoped>
  /* Estilos generales del contenedor y el carrusel */
  .carousel-wrapper {
    width: 90%; /* Ajusta el ancho según tu preferencia */
    max-width: 1000px;
    overflow: hidden; /* Oculta los ítems que no están en el centro */
    position: relative;
    padding: 20px 0; /* Espacio para que el zoom no se corte en los bordes */
    margin: 0 auto; /* Centrar el wrapper */
  }
  
  .carousel-track {
    display: flex;
  }
  
  .carousel-item {
    min-width: 300px; /* Ancho base de cada ítem */
    height: 250px; /* Altura fija para los ítems */
    margin: 0 15px; /* Espacio entre los ítems */
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-family: sans-serif;
    font-size: 1.1em;
    color: #333;
    flex-shrink: 0;
    transform: scale(1); /* Escala inicial */
    transition: transform 0.3s ease-in-out; /* Transición suave para el zoom */
    
  }
  
  .carousel-item img {
    max-width: 80%;
    max-height: 120px; /* Limita la altura de la imagen dentro del item */
    object-fit: contain; /* Asegura que la imagen quepa sin cortarse */
    border-radius: 6px;
    margin-bottom: 10px;
  }
  
  /* Efecto de aumento al pasar el mouse (hover) */
  .carousel-item:hover {
    transform: scale(1.15); /* Valor fijo del 15% de aumento */
    z-index: 10; /* Asegura que el ítem agrandado esté por encima de otros */
    cursor: pointer;
  }
  
  /* Flechas de navegación */
  .carousel-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    padding: 10px 15px;
    cursor: pointer;
    font-size: 1.5em;
    border-radius: 5px;
    z-index: 20;
    user-select: none; /* Evita selección de texto */
  }
  
  .carousel-arrow.left {
    left: 10px;
  }
  
  .carousel-arrow.right {
    right: 10px;
  }
  </style>